import * as Yup from 'yup';

export const initialValuesContactForm = {
    modelNumber: '',
    supplierName: '',
    brand: '',
    supplierId: '',
    brandId: '',
    location: '',
    status: 'active',
    sku: '',
    supplierUpc: '',
    internalUpc: '',
    isTaxable: false,
    defaultTaxPercentage: 0.00,
    supplierCost: '',
    landingCost: '',
    listPrice: '',
    photos: '',
    properties: {
        contactLensType: '',
        material: '',
        wearSchedule: '',
        packSize: '',
        sphere: '',
        cyl: '',
        axis: '',
        add: '',
        bc: '',
        dia: '',
        color: '',
        expirationDate: '',
        isTrial: false,
    },
    markupMultiplier: '1.0',
    profit: '',
    profitPercentage: '',
    lastOrdered: '',
    lastReceived: '',
    lastSold: '',
    totalSold: '',
    returned: '',
    quantityOnOrder: '',
    quantityOnHand: '',
    notes: ''
};

const contactValidationSchema = Yup.object({
    modelNumber: Yup.string().required('Model number is required'),
    supplierName: Yup.string().required('Supplier name is required'),
    brand: Yup.string().required('Brand is required'),
    properties: Yup.object({
        contactLensType: Yup.string(),
        packSize: Yup.number().nullable(),
        sphere: Yup.number().nullable(),
        cyl: Yup.number().nullable(),
        axis: Yup.number().nullable(),
        bc: Yup.number().nullable(),
        dia: Yup.number().nullable(),
        color: Yup.string(),
        expiryDate: Yup.date().nullable()
    })
});

export default contactValidationSchema;